import azureDevOpsService from './azureDevOpsService';

const BASE = '/api/rootcause';

function authHeaders() {
  const pat = azureDevOpsService.getPat();
  return pat ? { 'X-Azure-Devops-Pat': pat } : {};
}

const rootCauseService = {
  async getForBuild(pipelineId, buildId) {
    const res = await fetch(`${BASE}?pipelineId=${pipelineId}&buildId=${buildId}`, {
      headers: authHeaders()
    });
    if (!res.ok) throw new Error('rootcause fetch failed');
    const data = await res.json();
    const rootCauses = {};
    const notes = {};
    for (const entry of Object.values(data)) {
      if (entry.rootCause) rootCauses[entry.testName] = entry.rootCause;
      if (entry.notes) notes[entry.testName] = entry.notes;
    }
    return { rootCauses, notes };
  },

  async setNotes({ pipelineId, buildId, testName, notes }) {
    const res = await fetch(BASE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify({ pipelineId, buildId, testName, notes })
    });
    if (!res.ok) throw new Error('rootcause setNotes failed');
    return res.json();
  },

  async set({ pipelineId, buildId, runId, testName, rootCause, squad, buildDate, version }) {
    const v = version !== undefined ? version : (() => { try { return localStorage.getItem('activeVersion') || null; } catch { return null; } })();
    const res = await fetch(BASE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify({ pipelineId, buildId, runId, testName, rootCause, squad, buildDate, version: v })
    });
    if (!res.ok) throw new Error('rootcause set failed');
    return res.json();
  },

  async remove({ pipelineId, buildId, testName }) {
    const res = await fetch(BASE, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify({ pipelineId, buildId, testName })
    });
    if (!res.ok) throw new Error('rootcause delete failed');
    return res.json();
  },

  async getKpi(days = 90) {
    const res = await fetch(`${BASE}/kpi?days=${days}`, {
      headers: authHeaders()
    });
    if (!res.ok) throw new Error('rootcause kpi fetch failed');
    return res.json();
  }
};

export default rootCauseService;
